import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var InvoiceFilterActionInline;
(function (InvoiceFilterActionInline) {
    InvoiceFilterActionInline["INCLUDE"] = "INCLUDE";
    InvoiceFilterActionInline["EXCLUDE"] = "EXCLUDE";
})(InvoiceFilterActionInline || (InvoiceFilterActionInline = {}));
export var Invoicing;
(function (Invoicing) {
    Invoicing["NONE"] = "NONE";
    Invoicing["AFTER_RUNTIME"] = "AFTER_RUNTIME";
    Invoicing["START_RUNTIME"] = "START_RUNTIME";
    Invoicing["IMMEDIATELY"] = "IMMEDIATELY";
    Invoicing["CREDIT"] = "CREDIT";
    Invoicing["BY_POSITION_END_DATE_MONTH"] = "BY_POSITION_END_DATE_MONTH";
    Invoicing["BY_POSITION_END_DATE_QUARTER"] = "BY_POSITION_END_DATE_QUARTER";
    Invoicing["BY_POSITION_END_DATE_HALFYEAR"] = "BY_POSITION_END_DATE_HALFYEAR";
})(Invoicing || (Invoicing = {}));
export var InvoiceGenerationResponse;
(function (InvoiceGenerationResponse) {
    InvoiceGenerationResponse["REQUESTED"] = "REQUESTED";
    InvoiceGenerationResponse["SCHEDULED"] = "SCHEDULED";
})(InvoiceGenerationResponse || (InvoiceGenerationResponse = {}));
export var InvoiceApproveStatus;
(function (InvoiceApproveStatus) {
    InvoiceApproveStatus["STARTED"] = "STARTED";
    InvoiceApproveStatus["FAILED"] = "FAILED";
    InvoiceApproveStatus["FINISHED"] = "FINISHED";
})(InvoiceApproveStatus || (InvoiceApproveStatus = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["OPEN"] = "OPEN";
    PaymentStatus["DONE"] = "DONE";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentFileType;
(function (PaymentFileType) {
    PaymentFileType["CAMT"] = "CAMT";
    PaymentFileType["MT"] = "MT";
})(PaymentFileType || (PaymentFileType = {}));
export var CustomInvoiceIdRangeStatus;
(function (CustomInvoiceIdRangeStatus) {
    CustomInvoiceIdRangeStatus["ACTIVE"] = "ACTIVE";
    CustomInvoiceIdRangeStatus["FULL"] = "FULL";
})(CustomInvoiceIdRangeStatus || (CustomInvoiceIdRangeStatus = {}));
export var InvoiceState;
(function (InvoiceState) {
    InvoiceState["ALL"] = "ALL";
    InvoiceState["NONE"] = "NONE";
    InvoiceState["OPEN"] = "OPEN";
    InvoiceState["CHARGED"] = "CHARGED";
    InvoiceState["CANCELED"] = "CANCELED";
    InvoiceState["EXPORTED_TO_BEXIO"] = "EXPORTED_TO_BEXIO";
    InvoiceState["PAID"] = "PAID";
    InvoiceState["FIRST_REMINDER"] = "FIRST_REMINDER";
    InvoiceState["SECOND_REMINDER"] = "SECOND_REMINDER";
    InvoiceState["THIRD_REMINDER"] = "THIRD_REMINDER";
    InvoiceState["PERSONAL_CALL_REMINDER"] = "PERSONAL_CALL_REMINDER";
    InvoiceState["PERSONAL_CALL_REQUESTED_REMINDER"] = "PERSONAL_CALL_REQUESTED_REMINDER";
    InvoiceState["COLLECTION_REMINDER"] = "COLLECTION_REMINDER";
    InvoiceState["BAD_DEBT"] = "BAD_DEBT";
    InvoiceState["MANUAL_ARCHIVED"] = "MANUAL_ARCHIVED";
    InvoiceState["AUTO_ARCHIVED"] = "AUTO_ARCHIVED";
    InvoiceState["SPLIT"] = "SPLIT";
})(InvoiceState || (InvoiceState = {}));
export var InvoiceProcessingError;
(function (InvoiceProcessingError) {
    InvoiceProcessingError["NO_INVOICE_POSITIONS_APPROVAL_ERROR"] = "NO_INVOICE_POSITIONS_APPROVAL_ERROR";
})(InvoiceProcessingError || (InvoiceProcessingError = {}));
export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode["VISIBLE"] = "VISIBLE";
    VisibilityMode["HIDDEN"] = "HIDDEN";
    VisibilityMode["TRANSPARENT"] = "TRANSPARENT";
})(VisibilityMode || (VisibilityMode = {}));
export var CampaignStage;
(function (CampaignStage) {
    CampaignStage["OFFERED"] = "OFFERED";
    CampaignStage["OFFER_DENIED"] = "OFFER_DENIED";
    CampaignStage["ALTERNATE_QUOTE"] = "ALTERNATE_QUOTE";
    CampaignStage["BOOKED"] = "BOOKED";
    CampaignStage["PERFORMANCE"] = "PERFORMANCE";
    CampaignStage["DRAFT"] = "DRAFT";
    CampaignStage["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CampaignStage["ARCHIVED"] = "ARCHIVED";
    CampaignStage["PREPAYMENT"] = "PREPAYMENT";
})(CampaignStage || (CampaignStage = {}));
export var ExportType;
(function (ExportType) {
    ExportType["JSON"] = "JSON";
    ExportType["SAP"] = "SAP";
    ExportType["ABACUS"] = "ABACUS";
    ExportType["BEXIO"] = "BEXIO";
    ExportType["SAGE"] = "SAGE";
    ExportType["NONE"] = "NONE";
})(ExportType || (ExportType = {}));
export var Protocol;
(function (Protocol) {
    Protocol["FTPS"] = "FTPS";
    Protocol["FTP"] = "FTP";
    Protocol["SFTP"] = "SFTP";
    Protocol["SMB"] = "SMB";
})(Protocol || (Protocol = {}));
export var AccountReferenceType;
(function (AccountReferenceType) {
    AccountReferenceType["CUSTOMER_EXTERNAL_NUMBER"] = "CUSTOMER_EXTERNAL_NUMBER";
    AccountReferenceType["ACCOUNT_EXTERNAL_REFERENCE"] = "ACCOUNT_EXTERNAL_REFERENCE";
    AccountReferenceType["ACCOUNT_ID"] = "ACCOUNT_ID";
})(AccountReferenceType || (AccountReferenceType = {}));
export var BookingDateType;
(function (BookingDateType) {
    BookingDateType["CLOSE_DATE"] = "CLOSE_DATE";
    BookingDateType["INVOICE_DATE"] = "INVOICE_DATE";
    BookingDateType["MIN_POSITION_START_DATE"] = "MIN_POSITION_START_DATE";
    BookingDateType["MAX_POSITION_START_DATE"] = "MAX_POSITION_START_DATE";
    BookingDateType["MIN_POSITION_END_DATE"] = "MIN_POSITION_END_DATE";
    BookingDateType["MAX_POSITION_END_DATE"] = "MAX_POSITION_END_DATE";
})(BookingDateType || (BookingDateType = {}));
